import React from 'react';
import axios from '../../../axios-config.js';
import {connect} from 'react-redux';
import {closeModal} from '../../../Redux/actions/ui.js';

const responseGoogle = (response) => {
  console.log(response);
}


class RegisterInterest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactName:"",
      companyName:"",
      projectName:"",
      email:"",
      phone:"",
      description:"",
      submitted:false,
    }
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({
      contactName:"",
      companyName:"",
      projectName:"",
      email:"",
      phone:"",
      description:"",
      authorized:false,
      submitted:false
    })
    this.props.closeModal();
  }

  handleInput(data) {
    let tState = this.state;
    tState[data.key] = data.value;
    this.setState(tState);
  }

  handleSubmit() {
    let formValues = this.state;
    axios.post('/requestinterest',{
      contactName:formValues.contactName,
      companyName:formValues.companyName,
      email:formValues.email,
      phone:formValues.phone
    })
    .then((response) => {
      this.setState({submitted:true});
    })
    .catch((error) => {
    })
  }

  render() {
    let style = {
      "display":"flex",
      "flexDirection":"column",
      "pointerEvents":"auto",
      "padding":"10px",
      "backgroundColor":"#333333",
      "fontSize":"20px",
      "color":"#FFFFFF",
      "fontFamily":'Sans-Serif'
    }
    let textAreaStyle = {
      width:"450px",
      height:"250px"
    }
    let state = this.state;
    if (state.submitted) {
      return (
        <div style={style}>
        Thank you for registering interest in Inventum3D. <br/> We will contact you to discuss.<br/>
        <input type="Submit" value="Close" onClick={this.handleClose}/>
        </div>
      )
    }
    return (
      <div style={style}>
        <div>Register Account</div>
        <div>
        </div>
        <div style={{fontSize:"14px",width:"450px",fontStyle:"italic"}}>Inventum3D is still in beta. To get updates enter your contact details below.</div>
          <input type="text" value={state.contactName} placeholder="Name" onChange={(e)=>{this.handleInput({key:"contactName",value:e.target.value})}} />
          <input type="text" value={state.companyName} placeholder="Company Name (Optional)" onChange={(e)=>{this.handleInput({key:"companyName",value:e.target.value})}} />
          <input type="text" value={state.email} placeholder="Email" onChange={(e)=>{this.handleInput({key:"email",value:e.target.value})}} />
          <input type="text" value={state.phone} placeholder="Phone (Optional)" onChange={(e)=>{this.handleInput({key:"phone",value:e.target.value})}} />
          <input type="Submit" defaultValue="Submit" onClick={this.handleSubmit}/>
          <input type="Submit" defaultValue="Cancel" onClick={this.handleClose}/>
      </div>
    )
  }
}

/*
<GoogleLogin
   clientId="992705493990-9qrb5375eur86ta59eenv8a1dvsmj7jf.apps.googleusercontent.com"
   buttonText="Sign In"
   onSuccess={responseGoogle}
   onFailure={responseGoogle}
   cookiePolicy={'single_host_origin'}
 />
*/

let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  }
})

let mapStateToProps = (state) => ({
})

const RegisterInterestContainer = connect(mapStateToProps,mapDispatchToProps)(RegisterInterest)


export default RegisterInterestContainer
